import {
  CollectionStream,
  emptyCollectionStream,
  toCollectionStream,
} from 'streams/utils/streamUtils';
import {
  APIScenarioAttributes,
  CreateScenarioResponse,
  ResourceType,
} from '@ardoq/api-types';

import {
  reducedStream,
  streamReducer,
  toPersistentStream,
} from '@ardoq/rxbeach';
import { map } from 'rxjs/operators';
import { fetchAllReducer } from 'streams/crud/reducers';
import { removeEntityById } from '@ardoq/common-helpers';
import { filterResourceType, websocket$ } from 'sync/websocket$';
import { scenarioNamespace } from './actions';
import { ArdoqEvent, EventType } from 'sync/types';
import { logWarn } from '@ardoq/logging';

const resetScenarios = (
  _: APIScenarioAttributes[],
  scenarios: APIScenarioAttributes[]
): APIScenarioAttributes[] => scenarios;

const updateScenario = (
  state: APIScenarioAttributes[],
  scenario: APIScenarioAttributes
): APIScenarioAttributes[] => {
  const newModels = state.map(existingScenario =>
    existingScenario._id === scenario._id ? scenario : existingScenario
  );

  return resetScenarios(state, newModels);
};

const createScenario = (
  state: APIScenarioAttributes[],
  response: CreateScenarioResponse
): APIScenarioAttributes[] =>
  resetScenarios(state, [response.scenario, ...state]);

export type ScenariosState = CollectionStream<APIScenarioAttributes>;

// It's a bit sucky to not be able to use the premade websocketReducer, but because
// create returns both a permission and a scenario, we need to specialize on this
// Should probs make some support for this over in `streams/reducers`
const websocketReducer = (
  state: APIScenarioAttributes[],
  event: ArdoqEvent<any>
): APIScenarioAttributes[] => {
  const eventType = event['event-type'];
  switch (eventType) {
    case EventType.DELETE:
      return removeEntityById(state, event.data._id);
    case EventType.CREATE:
      return createScenario(state, event.data);
    case EventType.UPDATE:
      return updateScenario(state, event.data);
    default:
      logWarn(new Error(`Unknown event-type "${eventType}"`));
  }
  return state;
};

const scenariosList$ = reducedStream<APIScenarioAttributes[]>(
  'scenarios$',
  [],
  [
    fetchAllReducer(resetScenarios),
    streamReducer(
      websocket$.pipe(
        filterResourceType<APIScenarioAttributes>(ResourceType.SCENARIO)
      ),
      websocketReducer
    ),
  ],
  { namespace: scenarioNamespace }
);

export const scenarios$ = toPersistentStream(
  'scenarioState$',
  scenariosList$.pipe(map(toCollectionStream)),
  emptyCollectionStream()
);
